import React, { useState, useEffect } from "react";
import "./howitworks.scss";
import { motion } from "framer-motion";
import { HashLink as Link } from 'react-router-hash-link';

const Howitworks = () => {
  const defaultOpenIndex = 0; // 👈 FIRST CARD OPEN BY DEFAULT

  const [hoveredCard, setHoveredCard] = useState(defaultOpenIndex);
  const [lastActiveCard, setLastActiveCard] = useState(defaultOpenIndex);
  const [isMobile, setIsMobile] = useState(false);
  const [activeStep, setActiveStep] = useState(0);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleCardClick = (index) => {
    setHoveredCard(index);
    setLastActiveCard(index);
  };

  const handleMouseEnter = (index) => {
    if (isMobile) return;
    setHoveredCard(index);
    setLastActiveCard(index);
  };

  const cards = [
    {
      num: "01",
      numouter: "#1",
      title: "A Builder-First Approach",
      img: "/assets/one.svg",
      svg: <><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M12.83 2.17999C12.5694 2.06114 12.2864 1.99963 12 1.99963C11.7136 1.99963 11.4305 2.06114 11.17 2.17999L2.59996 6.07999C2.42251 6.15823 2.27164 6.28639 2.16573 6.44885C2.05981 6.61131 2.00342 6.80106 2.00342 6.99499C2.00342 7.18893 2.05981 7.37868 2.16573 7.54113C2.27164 7.70359 2.42251 7.83175 2.59996 7.90999L11.18 11.82C11.4405 11.9388 11.7236 12.0003 12.01 12.0003C12.2964 12.0003 12.5794 11.9388 12.84 11.82L21.42 7.91999C21.5974 7.84175 21.7483 7.71359 21.8542 7.55113C21.9601 7.38868 22.0165 7.19893 22.0165 7.00499C22.0165 6.81106 21.9601 6.6213 21.8542 6.45885C21.7483 6.29639 21.5974 6.16823 21.42 6.08999L12.83 2.17999Z" stroke="#E5FE00" stroke-width="1.92522" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M2 12C1.99953 12.1913 2.05392 12.3787 2.15672 12.5399C2.25952 12.7012 2.40642 12.8297 2.58 12.91L11.18 16.82C11.4392 16.9374 11.7205 16.9981 12.005 16.9981C12.2895 16.9981 12.5708 16.9374 12.83 16.82L21.41 12.92C21.587 12.8404 21.737 12.7111 21.8418 12.5477C21.9466 12.3844 22.0015 12.1941 22 12" stroke="#E5FE00" stroke-width="1.92522" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M2 16.9997C1.99953 17.1909 2.05392 17.3783 2.15672 17.5396C2.25952 17.7009 2.40642 17.8293 2.58 17.9097L11.18 21.8197C11.4392 21.937 11.7205 21.9977 12.005 21.9977C12.2895 21.9977 12.5708 21.937 12.83 21.8197L21.41 17.9197C21.587 17.8401 21.737 17.7108 21.8418 17.5474C21.9466 17.384 22.0015 17.1937 22 16.9997" stroke="#E5FE00" stroke-width="1.92522" stroke-linecap="round" stroke-linejoin="round" />
      </svg></>,
      desc: "Rain isn't just a data feed - it’s a construction kit. It is the only protocol that gives you the tools to build a complete prediction ecosystem from the ground up.",
    },
    {
      num: "02",
      numouter: "#2",
      title: "A Business Model That Pays",
      img: "/assets/cam.svg",
      svg: <><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M12 18H4C3.46957 18 2.96086 17.7893 2.58579 17.4142C2.21071 17.0391 2 16.5304 2 16V8C2 7.46957 2.21071 6.96086 2.58579 6.58579C2.96086 6.21071 3.46957 6 4 6H20C20.5304 6 21.0391 6.21071 21.4142 6.58579C21.7893 6.96086 22 7.46957 22 8V13" stroke="#8559E3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M16 19L19 22L22 19" stroke="#8559E3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M18 12H18.01" stroke="#8559E3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M19 16V22" stroke="#8559E3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M6 12H6.01" stroke="#8559E3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z" stroke="#8559E3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg></>,
      desc: "Builders earn a percentage of the total trading volume generated by markets created on their apps. An additional percentage goes directly to the protocol for the strategic buyback and burn of $RAIN.",
    },
    {
      num: "03",
      numouter: "#3",
      title: "Built-in Monetization Mechanism",
      img: "/assets/three.svg",
      svg: <><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M11 15H13C13.5304 15 14.0391 14.7893 14.4142 14.4142C14.7893 14.0391 15 13.5304 15 13C15 12.4696 14.7893 11.9609 14.4142 11.5858C14.0391 11.2107 13.5304 11 13 11H10C9.4 11 8.9 11.2 8.6 11.6L3 17" stroke="#FF5C32" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M7 21L8.6 19.6C8.9 19.2 9.4 19 10 19H14C15.1 19 16.1 18.6 16.8 17.8L21.4 13.4C21.7859 13.0353 22.0111 12.5323 22.0261 12.0016C22.0411 11.4708 21.8447 10.9559 21.48 10.57C21.1153 10.1841 20.6123 9.95889 20.0816 9.94389C19.5508 9.92888 19.0359 10.1253 18.65 10.49L14.45 14.39" stroke="#FF5C32" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M2 16L8 22" stroke="#FF5C32" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M16.0001 11.9C17.6017 11.9 18.9001 10.6016 18.9001 9.00001C18.9001 7.39838 17.6017 6.10001 16.0001 6.10001C14.3985 6.10001 13.1001 7.39838 13.1001 9.00001C13.1001 10.6016 14.3985 11.9 16.0001 11.9Z" stroke="#FF5C32" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M6 8C7.65685 8 9 6.65685 9 5C9 3.34315 7.65685 2 6 2C4.34315 2 3 3.34315 3 5C3 6.65685 4.34315 8 6 8Z" stroke="#FF5C32" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg></>,
      desc: "Rewards for creators, liquidity providers and referrals.",
    },
    {
      num: "04",
      numouter: "#4",
      title: "Major Grants Program",
      img: "/assets/four.svg",
      svg: <><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M10 18V11" stroke="#99FF80" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M11.1201 2.198C11.3945 2.06471 11.6957 1.99595 12.0008 1.99699C12.3059 1.99803 12.6066 2.06884 12.8801 2.204L20.7461 6.051C21.2221 6.284 21.0561 7 20.5261 7H3.4741C2.9441 7 2.7791 6.284 3.2541 6.051L11.1201 2.198Z" stroke="#99FF80" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M14 18V11" stroke="#99FF80" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M18 18V11" stroke="#99FF80" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M3 22H21" stroke="#99FF80" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M6 18V11" stroke="#99FF80" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg></>,
      desc: "We have allocated a significant funding pool to support developers creating unique, high-impact applications on Rain.",
    },
    {
      num: "05",
      numouter: "#5",
      title: "True Decentralization",
      img: "/assets/true.svg",
      svg: <><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="#12AAFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M12 2C9.43223 4.69615 8 8.27674 8 12C8 15.7233 9.43223 19.3038 12 22C14.5678 19.3038 16 15.7233 16 12C16 8.27674 14.5678 4.69615 12 2Z" stroke="#12AAFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M2 12H22" stroke="#12AAFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg></>,
      desc: "From liquidity pools to disputes, Rain provides a permissionless environment where transparency and trustlessness are built into the code.",
    },
  ];

  return (
    <div className="outer-layer-works">
      <section className="main_live">
        <div className="top-mainlive">
          <div className="custom-container">
            <div className="innner_live">
              <div className="keyyinner">
                <h1>Why Build on Rain?</h1>
                <p>
                  Everything you need to build powerful, scalable prediction
                  market applications
                </p>
              </div>
            </div>
            {
              !isMobile ? <>
                <div className="multiples_cards">
                  {cards.map((card, index) => (
                    <motion.div
                      key={index}
                      className={`onesss card-${index + 1}`}
                      layout
                      transition={{ duration: 0.5, ease: "easeInOut" }}
                      // onMouseEnter={() => handleMouseEnter(index)}
                      onClick={() => handleCardClick(index)}
                    >
                      {hoveredCard === index ? (
                        <motion.div
                          className={`open_cards open-card-${index + 1}`}
                          initial={{ opacity: 0, y: 20 }}
                          animate={{ opacity: 1, y: 0 }}
                          transition={{ duration: 0.4 }}
                        >
                          {/* SVGs + Content unchanged */}
                          <svg className="svgopen" xmlns="http://www.w3.org/2000/svg" width="708" height="512" viewBox="0 0 708 512" fill="none">
                            <path d="M0 14.8113C0 6.6313 6.63123 7.13373e-05 14.8113 6.99287e-05L413.351 1.29848e-06C418.089 4.82646e-07 422.54 2.26634 425.328 6.09723L458.268 51.3705C461.055 55.2014 465.507 57.4677 470.245 57.4677L693.168 57.4678C701.348 57.4678 707.979 64.099 707.979 72.2791V496.277C707.979 504.458 701.348 511.089 693.168 511.089H14.8113C6.63124 511.089 0 504.458 0 496.277V14.8113Z" fill="#111111" />
                            <path d="M14.8115 0.592773H413.351C417.899 0.592773 422.173 2.76782 424.849 6.44531L457.789 51.7188C460.688 55.7028 465.317 58.0604 470.244 58.0605H693.168C701.021 58.0607 707.387 64.4266 707.387 72.2793V496.277C707.387 504.13 701.021 510.496 693.168 510.496H14.8115C6.95869 510.496 0.592773 504.13 0.592773 496.277V14.8115C0.592773 6.95869 6.95869 0.592775 14.8115 0.592773Z" stroke="#DAD9D9" strokeOpacity="0.3" strokeWidth="1.1849" />
                          </svg>

                          <svg className="svgopenn" xmlns="http://www.w3.org/2000/svg" width="394" height="511" viewBox="0 0 394 511" fill="none">
                            <path d="M0 14.8114C0 6.63132 6.63123 6.91954e-05 14.8113 6.516e-05L139.358 3.71928e-06C144.095 1.38242e-06 148.546 2.26581 151.333 6.09594L184.276 51.3618C187.063 55.1919 191.514 57.4578 196.251 57.4578L379.189 57.4578C387.369 57.4578 394 64.0891 394 72.2691V496.189C394 504.369 387.369 511 379.189 511H14.8113C6.63123 511 0 504.369 0 496.189V14.8114Z" fill="#111111" />
                            <path d="M14.8115 0.592773H139.357C143.905 0.592771 148.179 2.76746 150.854 6.44434L183.797 51.71C186.696 55.6933 191.325 58.0498 196.252 58.0498H379.188C387.041 58.0498 393.407 64.4167 393.407 72.2695V496.188C393.407 504.041 387.041 510.407 379.188 510.407H14.8115C6.95869 510.407 0.592773 504.041 0.592773 496.188V14.8115C0.592773 6.95869 6.95869 0.592777 14.8115 0.592773Z" stroke="#DAD9D9" strokeOpacity="0.3" strokeWidth="1.1849" />
                          </svg>

                          <div className="cardsnew">
                            <div className="innernewcards">
                              <img src={card.img} alt="" />
                              <h4>{card.num}</h4>
                            </div>
                            <h5>{card.title}</h5>
                            <h6>{card.desc}</h6>
                          </div>
                        </motion.div>
                      ) : (
                        <motion.div
                          className={`long_cards long-card-${index + 1}`}
                          initial={{ opacity: 0.8, y: 10 }}
                          animate={{ opacity: 1, y: 0 }}
                          transition={{ duration: 0.3 }}
                        >
                          {/* SVGs + Title unchanged */}
                          <svg className="svgopen" xmlns="http://www.w3.org/2000/svg" width="100" height="455" viewBox="0 0 100 455" fill="none">
                            <path d="M0 14.8153C0 6.63303 6.63301 0 14.8152 0H85.1848C93.367 0 100 6.63301 100 14.8152V440.185C100 448.367 93.367 455 85.1848 455H14.8152C6.63301 455 0 448.367 0 440.185V14.8153Z" fill="#111111" />
                            <path d="M14.8154 0.479492H85.1846C93.102 0.479492 99.5205 6.89799 99.5205 14.8154V440.185C99.5205 448.102 93.102 454.521 85.1846 454.521H14.8154C6.898 454.521 0.479492 448.102 0.479492 440.185V14.8154C0.479492 6.89799 6.898 0.479492 14.8154 0.479492Z" stroke="#DAD9D9" strokeOpacity="0.3" strokeWidth="0.958915" />
                          </svg>

                          <svg className="svgopenn" xmlns="http://www.w3.org/2000/svg" width="395" height="99" viewBox="0 0 395 99" fill="none">
                            <path d="M380.185 1.46112e-05C388.367 1.49689e-05 395 6.63303 395 14.8153L395 84.1848C395 92.367 388.367 99 380.185 99L14.8152 99C6.63302 99 -4.03749e-06 92.367 -3.67983e-06 84.1848L-6.47595e-07 14.8152C-2.89938e-07 6.63301 6.63303 -1.71727e-06 14.8152 -1.35961e-06L380.185 1.46112e-05Z" fill="#111111" />
                            <path d="M394.521 14.8154L394.521 84.1846C394.521 92.102 388.102 98.5205 380.185 98.5205L14.8154 98.5205C6.898 98.5205 0.479488 92.102 0.479489 84.1846L0.479492 14.8154C0.479492 6.89799 6.89801 0.47949 14.8154 0.479491L380.185 0.479507C388.102 0.479507 394.521 6.89801 394.521 14.8154Z" stroke="#DAD9D9" strokeOpacity="0.3" strokeWidth="0.958915" />
                          </svg>

                          <h4>
                            {card.numouter} <span>-{card.title}</span>
                          </h4>
                        </motion.div>
                      )}
                    </motion.div>
                  ))}
                </div>
              </> : <>
                <div className="parent-mobile-build">
                  <div className="upper-options">
                    <span className="line-calc"></span>

                    {cards.map((card, index) => (
                      <div
                        key={index}
                        className={`single-option ${activeStep === index ? "active" : ""}`}
                        onClick={() => setActiveStep(index)}
                      >
                        {card.svg}
                      </div>
                    ))}
                  </div>
                  <div className="bottom-body" style={{overflow: "hidden"}}>
                    <div className="mobile-step-content">
                      <motion.div
                        key={activeStep}
                        initial={{ opacity: 0, x: 50 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.5 }}
                      >
                        <h6>{cards[activeStep].title}</h6>
                        <p>{cards[activeStep].desc}</p>
                      </motion.div>
                    </div>
                  </div>
                </div>
              </>
            }




            <div className="buttons_both">
              <Link to="/builders#program" smooth>
                <button className="applybutton">Apply for a Grant</button>
              </Link>
              {/* <button className="readbutton">Read the Docs</button> */}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Howitworks;
